/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientSurveyQuestionModel } from '../models/client-survey-question-model';
import { createSurveyquestion$Json } from '../fn/survey-question/create-surveyquestion-json';
import { CreateSurveyquestion$Json$Params } from '../fn/survey-question/create-surveyquestion-json';
import { createSurveyquestion$Plain } from '../fn/survey-question/create-surveyquestion-plain';
import { CreateSurveyquestion$Plain$Params } from '../fn/survey-question/create-surveyquestion-plain';
import { deleteSurveyQuestion } from '../fn/survey-question/delete-survey-question';
import { DeleteSurveyQuestion$Params } from '../fn/survey-question/delete-survey-question';
import { getSurveyQuestion$Json } from '../fn/survey-question/get-survey-question-json';
import { GetSurveyQuestion$Json$Params } from '../fn/survey-question/get-survey-question-json';
import { getSurveyQuestion$Plain } from '../fn/survey-question/get-survey-question-plain';
import { GetSurveyQuestion$Plain$Params } from '../fn/survey-question/get-survey-question-plain';
import { getSurveyQuestions$Json } from '../fn/survey-question/get-survey-questions-json';
import { GetSurveyQuestions$Json$Params } from '../fn/survey-question/get-survey-questions-json';
import { getSurveyQuestions$Plain } from '../fn/survey-question/get-survey-questions-plain';
import { GetSurveyQuestions$Plain$Params } from '../fn/survey-question/get-survey-questions-plain';
import { updateSurveyQuestion$Json } from '../fn/survey-question/update-survey-question-json';
import { UpdateSurveyQuestion$Json$Params } from '../fn/survey-question/update-survey-question-json';
import { updateSurveyQuestion$Plain } from '../fn/survey-question/update-survey-question-plain';
import { UpdateSurveyQuestion$Plain$Params } from '../fn/survey-question/update-survey-question-plain';

@Injectable({ providedIn: 'root' })
export class SurveyQuestionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveyQuestions()` */
  static readonly GetSurveyQuestionsPath = '/api/SurveyQuestion';

  /**
   * get list of surveyquestion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyQuestions$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyQuestions$Plain$Response(params: GetSurveyQuestions$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyQuestionModel>>> {
    return getSurveyQuestions$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get list of surveyquestion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyQuestions$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyQuestions$Plain(params: GetSurveyQuestions$Plain$Params, context?: HttpContext): Observable<Array<ClientSurveyQuestionModel>> {
    return this.getSurveyQuestions$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyQuestionModel>>): Array<ClientSurveyQuestionModel> => r.body)
    );
  }

  /**
   * get list of surveyquestion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyQuestions$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyQuestions$Json$Response(params: GetSurveyQuestions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyQuestionModel>>> {
    return getSurveyQuestions$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get list of surveyquestion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyQuestions$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyQuestions$Json(params: GetSurveyQuestions$Json$Params, context?: HttpContext): Observable<Array<ClientSurveyQuestionModel>> {
    return this.getSurveyQuestions$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyQuestionModel>>): Array<ClientSurveyQuestionModel> => r.body)
    );
  }

  /** Path part for operation `createSurveyquestion()` */
  static readonly CreateSurveyquestionPath = '/api/SurveyQuestion';

  /**
   * create new surveyquestion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyquestion$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyquestion$Plain$Response(params?: CreateSurveyquestion$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
    return createSurveyquestion$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * create new surveyquestion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyquestion$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyquestion$Plain(params?: CreateSurveyquestion$Plain$Params, context?: HttpContext): Observable<ClientSurveyQuestionModel> {
    return this.createSurveyquestion$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyQuestionModel>): ClientSurveyQuestionModel => r.body)
    );
  }

  /**
   * create new surveyquestion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurveyquestion$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyquestion$Json$Response(params?: CreateSurveyquestion$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
    return createSurveyquestion$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * create new surveyquestion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurveyquestion$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurveyquestion$Json(params?: CreateSurveyquestion$Json$Params, context?: HttpContext): Observable<ClientSurveyQuestionModel> {
    return this.createSurveyquestion$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyQuestionModel>): ClientSurveyQuestionModel => r.body)
    );
  }

  /** Path part for operation `getSurveyQuestion()` */
  static readonly GetSurveyQuestionPath = '/api/SurveyQuestion/{surveyQuestionId}';

  /**
   * get surveyquestion by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyQuestion$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyQuestion$Plain$Response(params: GetSurveyQuestion$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
    return getSurveyQuestion$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveyquestion by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyQuestion$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyQuestion$Plain(params: GetSurveyQuestion$Plain$Params, context?: HttpContext): Observable<ClientSurveyQuestionModel> {
    return this.getSurveyQuestion$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyQuestionModel>): ClientSurveyQuestionModel => r.body)
    );
  }

  /**
   * get surveyquestion by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveyQuestion$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyQuestion$Json$Response(params: GetSurveyQuestion$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
    return getSurveyQuestion$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get surveyquestion by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveyQuestion$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveyQuestion$Json(params: GetSurveyQuestion$Json$Params, context?: HttpContext): Observable<ClientSurveyQuestionModel> {
    return this.getSurveyQuestion$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyQuestionModel>): ClientSurveyQuestionModel => r.body)
    );
  }

  /** Path part for operation `updateSurveyQuestion()` */
  static readonly UpdateSurveyQuestionPath = '/api/SurveyQuestion/{surveyQuestionId}';

  /**
   * update surveyquestion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurveyQuestion$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyQuestion$Plain$Response(params: UpdateSurveyQuestion$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
    return updateSurveyQuestion$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * update surveyquestion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurveyQuestion$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyQuestion$Plain(params: UpdateSurveyQuestion$Plain$Params, context?: HttpContext): Observable<ClientSurveyQuestionModel> {
    return this.updateSurveyQuestion$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyQuestionModel>): ClientSurveyQuestionModel => r.body)
    );
  }

  /**
   * update surveyquestion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurveyQuestion$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyQuestion$Json$Response(params: UpdateSurveyQuestion$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyQuestionModel>> {
    return updateSurveyQuestion$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * update surveyquestion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurveyQuestion$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurveyQuestion$Json(params: UpdateSurveyQuestion$Json$Params, context?: HttpContext): Observable<ClientSurveyQuestionModel> {
    return this.updateSurveyQuestion$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyQuestionModel>): ClientSurveyQuestionModel => r.body)
    );
  }

  /** Path part for operation `deleteSurveyQuestion()` */
  static readonly DeleteSurveyQuestionPath = '/api/SurveyQuestion/{surveyQuestionId}';

  /**
   * delete surveyquestion.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyQuestion()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyQuestion$Response(params: DeleteSurveyQuestion$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSurveyQuestion(this.http, this.rootUrl, params, context);
  }

  /**
   * delete surveyquestion.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyQuestion$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyQuestion(params: DeleteSurveyQuestion$Params, context?: HttpContext): Observable<void> {
    return this.deleteSurveyQuestion$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
